import { ditColors } from "./theme";

export type ScoreBand = "red" | "yellow" | "green";

/**
 * Map a 1-5 score (or category/overall mean) to a color band.
 *
 *   score < 2.5         -> red    (1, 2, or "very weak" averages)
 *   2.5 <= score < 3.5  -> yellow (3, or "borderline" averages)
 *   score >= 3.5        -> green  (4, 5, or "strong" averages)
 */
export function bandFor(score: number): ScoreBand {
  if (!Number.isFinite(score)) return "yellow";
  if (score < 2.5) return "red";
  if (score < 3.5) return "yellow";
  return "green";
}

export interface BandTokens {
  bg: string;
  fg: string;
  /** Human-readable label for screen readers ("red" / "yellow" / "green"). */
  label: string;
}

export function tokensFor(band: ScoreBand): BandTokens {
  switch (band) {
    case "red":
      return { bg: ditColors.scoreRedBg, fg: ditColors.scoreRedFg, label: "red" };
    case "yellow":
      return {
        bg: ditColors.scoreYellowBg,
        fg: ditColors.scoreYellowFg,
        label: "yellow",
      };
    case "green":
      return { bg: ditColors.scoreGreenBg, fg: ditColors.scoreGreenFg, label: "green" };
  }
}

export function bandLabel(band: ScoreBand): string {
  switch (band) {
    case "red":
      return "Concern";
    case "yellow":
      return "Borderline";
    case "green":
      return "Strong";
  }
}
